export const BoundaryFill = {
  DefaultFill: 'DefaultFill',
  NoTerritoryFill: 'NoTerritoryFill',
  RandomizedFill: 'RandomizedFill',
} as const;

export type BoundaryFillType = typeof BoundaryFill[keyof typeof BoundaryFill];
